import { render } from "./AboutSection.vue?vue&type=template&id=cd4e0844&ts=true"
import script from "./AboutSection.vue?vue&type=script&lang=ts"
export * from "./AboutSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__